import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=bcb6a5bc&lang=less&scoped=true"

import exportComponent from "/Users/liuxiong/Documents/美通官网/huanshuntong/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcb6a5bc"]])

export default __exports__